import { Link, useLocation } from "react-router-dom";
import logoNaklejki3d from "@/assets/nowe-logo-naklejki-3d.png.asset.json";
import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import ColorThemeSwitcher from "./ColorThemeSwitcher";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  const navItems = [
    { label: t("nav.home"), path: "/" },
    { label: t("nav.products"), path: "/produkty" },
    { label: t("nav.applications"), path: "/zastosowania-branzowe" },
    { label: t("nav.realizations"), path: "/realizacje" },
    { label: t("nav.calculator"), path: "/kalkulator" },
    { label: t("nav.about"), path: "/o-nas" },
    { label: t("nav.knowledge"), path: "/baza-wiedzy" },
    { label: t("nav.blog"), path: "/blog" },
    { label: t("nav.contact"), path: "/kontakt" },
  ];

  return (
    <nav className="site-navbar fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b">
      <div className="container mx-auto px-4 flex items-center justify-between h-16 lg:h-[4.5rem]">
        <Link to="/" className="flex items-center">
          <img src={logoNaklejki3d.url} alt="naklejki-3d.com.pl – Naklejki 3D zalewane żywicą" width={160} height={56} className="h-10 lg:h-14 w-auto" />
        </Link>

        {/* Desktop nav */}
        <div className="hidden lg:flex items-center gap-1.5">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`site-nav-link px-4 py-2.5 rounded-md text-[0.938rem] font-medium transition-colors ${
                location.pathname === item.path
                  ? "site-nav-link-active"
                  : ""
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-4">
          <ColorThemeSwitcher />
          <LanguageSwitcher />
          <a href="tel:+48534900620" className="site-phone transition-colors flex items-center gap-1.5 text-[0.938rem]">
            <Phone className="w-[1.125rem] h-[1.125rem]" />
            +48 534 900 620
          </a>
          <Link
            to="/kalkulator"
            className="gradient-gold text-accent-foreground font-semibold px-6 py-3 rounded-md text-[0.938rem] hover:opacity-90 transition-opacity shadow-gold"
          >
            {t("nav.freeQuote")}
          </Link>
        </div>

        {/* Mobile toggle */}
        <div className="flex items-center gap-2 lg:hidden">
          <ColorThemeSwitcher />
          <LanguageSwitcher />
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="site-mobile-toggle p-2"
            aria-label={isOpen ? "Zamknij menu" : "Otwórz menu"}
            aria-expanded={isOpen}
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="site-mobile-menu lg:hidden border-t animate-fade-in">
          <div className="container mx-auto px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`site-nav-link px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === item.path
                    ? "site-nav-link-active bg-navy-light/20"
                    : ""
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/kalkulator"
              onClick={() => setIsOpen(false)}
              className="gradient-gold text-accent-foreground font-semibold px-5 py-3 rounded-md text-sm text-center mt-2 shadow-gold"
            >
              {t("nav.freeQuote")}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
